// extracted by mini-css-extract-plugin
module.exports = {"card":"mediaPoster_card__2vK_Y"};